import React from 'react';
import { Config } from '@leverege/plugin';
import { Content, Text, IconUtil } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './ErrorScreen.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.screens.support.ErrorScreen');
export default function ErrorScreen(props) {
  const {
    title,
    error,
    image
  } = props;
  const msg = typeof error === 'string' ? error : error?.message;
  const mTitle = title === undefined ? Config.get('ErrorScreen', 'title', t('title')) : title;
  const mMsg = msg === undefined ? Config.get('ErrorScreen', 'message', t('message')) : msg;
  const mImg = image === undefined ? Config.get('ErrorScreen', 'image', 'fa fa-meh-o') : image;
  return /*#__PURE__*/_jsx(Content, {
    horizontal: true,
    variant: "editor",
    children: /*#__PURE__*/_jsx(Content.Area, {
      children: /*#__PURE__*/_jsxs("div", {
        className: S.content,
        children: [mImg && /*#__PURE__*/_jsx("div", {
          className: S.fontIcon,
          children: IconUtil.create(mImg, {
            width: '60%'
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "title",
            children: mTitle
          }), /*#__PURE__*/_jsx(Text, {
            variant: "caption",
            children: mMsg
          })]
        })]
      })
    })
  });
}